import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { CircularProgress, IconButton } from '@mui/material';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTaskNavigation } from '../hooks/useTaskNavigation';

interface TaskNavigationProps {
  taskId: string | undefined;
  chainId: string | null;
  imageId: string | null;
  isLoading?: boolean;
}

export const TaskNavigation: React.FC<TaskNavigationProps> = ({
  taskId,
  chainId,
  imageId,
  isLoading = false,
}) => {
  const navigate = useNavigate();
  const { previousTaskUrl, nextTaskUrl } = useTaskNavigation({
    taskId,
    chainId,
    imageId,
  });

  const navigateToPreviousTask = useCallback(() => {
    if (previousTaskUrl) {
      navigate(previousTaskUrl, { replace: true });
    }
  }, [previousTaskUrl, navigate]);

  const navigateToNextTask = useCallback(() => {
    if (nextTaskUrl) {
      navigate(nextTaskUrl, { replace: true });
    }
  }, [nextTaskUrl, navigate]);

  return (
    <div className="flex gap-6">
      <IconButton
        title="Previous task"
        size="small"
        disabled={!previousTaskUrl || isLoading}
        onClick={navigateToPreviousTask}
        sx={{
          backgroundColor: 'rgba(0,0,0,0.05)',
        }}
      >
        {isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <ArrowBack fontSize="small" />
        )}
      </IconButton>
      <IconButton
        title="Next task"
        size="small"
        disabled={!nextTaskUrl || isLoading}
        onClick={navigateToNextTask}
        sx={{ backgroundColor: 'rgba(0,0,0,0.05)' }}
      >
        {isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <ArrowForward fontSize="small" />
        )}
      </IconButton>
    </div>
  );
};
